import { ISP_Fan } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { themedUseStyletron } from '../../../theme/customTheme'
import { IconFan } from './IconFan';
import { SmallPanel } from './SmallPanel';


export function OverviewPanel(props: ISP_Fan) {
    const [css, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper includeAlarmsFromChildren  {...props} icon={<IconFan color={theme.colors.backgroundPrimary} />}>
            <SmallPanel {...props} />
        </OverviewPanelWrapper>
    );
}